export default __webpack_public_path__ + "static/media/threeways.3336e245.png";